import { IExpression } from "@@expressions";
import { IComponent } from "./IComponent";
import { ConfirmmationDialogModel } from "./TableModel";

export type ButtonModel = IComponent & {
  Label?: string;
  IconName?: string;
  Variant?: ButtonVariant;
  ConfirmationDialog?: ConfirmmationDialogModel;
  OnSelected?: IExpression;
  View?: ButtonView;
  OnViewReturned?: IExpression;
  Disabled?: IExpression;
};

export type ButtonView = {
  Id: string;
  Input?: IExpression;
};

export enum ButtonVariant {
  Button = "Button",
  ButtonContained = "ButtonContained",
  ButtonOutlined = "ButtonOutlined",
  IconButton = "IconButton",
}




